import store from 'store';
import loadProfile from './load-profile';
import pushProfileToDataLayer from './push-profile-to-datalayer';
import identifyAnalyticsUser from './identify-analytics-user';

const postAuthStartup = async (): Promise<void> => {
  await store.dispatch(loadProfile);
  await pushProfileToDataLayer();
  await identifyAnalyticsUser();
};

export default postAuthStartup;
